var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.301,
    height: 35.161,
    viewBox: "0 0 29.301 35.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M29.836,5.86H25.294A7.338,7.338,0,0,0,18.116,0h-2.93A7.338,7.338,0,0,0,8.007,5.86H3.465a1.465,1.465,0,0,0,0,2.93H4.93V27.836a7.334,7.334,0,0,0,7.325,7.325h8.79a7.334,7.334,0,0,0,7.325-7.325V8.79h1.465a1.465,1.465,0,0,0,0-2.93ZM15.186,2.93h2.93A4.4,4.4,0,0,1,22.26,5.86H11.041a4.4,4.4,0,0,1,4.145-2.93ZM25.441,27.836a4.4,4.4,0,0,1-4.4,4.4h-8.79a4.4,4.4,0,0,1-4.4-4.4V8.79H25.441Z",
    transform: "translate(-2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M10.465,21.72a1.465,1.465,0,0,0,1.465-1.465v-8.79a1.465,1.465,0,0,0-2.93,0v8.79A1.465,1.465,0,0,0,10.465,21.72Z",
    transform: "translate(1.255 4.651)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M14.465,21.72a1.465,1.465,0,0,0,1.465-1.465v-8.79a1.465,1.465,0,1,0-2.93,0v8.79A1.465,1.465,0,0,0,14.465,21.72Z",
    transform: "translate(3.116 4.651)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a8a228f4aaa4c2d3959a644973ea3cfc.svg";
export { ForwardRef as ReactComponent };